import { FC, ReactNode, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useServices } from "../../services/Services";

interface WithActiveSubscriptionProps {
  children?: ReactNode;
}

const WithActiveSubscription: FC<WithActiveSubscriptionProps> = function ({
  children,
}) {
  const services = useServices();
  const { data: user, isSuccess: userLoaded } = services.User.useGetCurrent();
  const hasBypass = !!user?.paymentBypassReason;
  const { data: subscription, isSuccess: subscriptionLoaded } =
    services.User.useGetStripeDetails(hasBypass ? undefined : user?.email);
  const navigate = useNavigate();

  useEffect(() => {
    // Skip Stripe subscription check for payment bypass users
    if (
      !hasBypass &&
      subscriptionLoaded &&
      (!subscription || !subscription.inGoodStanding)
    ) {
      navigate("/subscription-expired");
      return;
    }
    // User status check applies to all users including bypass
    const isReady = hasBypass ? userLoaded : subscriptionLoaded && userLoaded;
    if (isReady && (!user || user.status !== "Active")) {
      navigate("/inactive-user");
      return;
    }
  }, [navigate, subscription, user, userLoaded, subscriptionLoaded, hasBypass]);

  return children ?? <Outlet />;
};

export default WithActiveSubscription;
